import { useEffect, useRef } from "react";

declare global {
  interface Window {
    _mgq?: unknown[];
  }
}

type MgidAdProps = {
  widgetId: string;
  minHeight?: number;
  label?: string;
  className?: string;
  /** Overlay formats (exit story, swipe up, in-site notification) render no visible slot. */
  overlay?: boolean;
};

/**
 * MGID widget container. The loader script (jsc.mgid.com/site/1109547.js) is in
 * <head>; here we only mount the container and trigger `_mgc.load` after the
 * element exists in the DOM (also works on client-side route changes).
 */
export function MgidAd({ widgetId, minHeight = 300, label = "Advertisement", className, overlay = false }: MgidAdProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const w = window;
    w._mgq = w._mgq || [];
    w._mgq.push(["_mgc.load"]);
  }, [widgetId]);

  if (overlay) {
    return (
      <div ref={ref} data-type="_mgwidget" data-widget-id={widgetId} suppressHydrationWarning />
    );
  }

  return (
    <div className={className}>
      <div className="mb-1 text-center text-[10px] uppercase tracking-widest text-muted-foreground/60">
        {label}
      </div>
      <div
        ref={ref}
        data-type="_mgwidget"
        data-widget-id={widgetId}
        style={{ minHeight }}
        suppressHydrationWarning
      />
    </div>
  );
}
